import type { SVGProps } from "react";
// generated from Pencil.svg — do not edit manually
// prettier-ignore
export default function Pencil(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 18 2 L 22 6 M 3.5 16.5 L 2.737 19.2987 C 2.495 20.1839 2.375 20.6266 2.491 20.9315 C 2.593 21.1974 2.803 21.4075 3.069 21.509 C 3.373 21.6254 3.816 21.5047 4.701 21.2633 L 7.5 20.5 L 19 9 L 15 5 L 3.5 16.5 Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></svg>);
}
